import { REQUEST_STATUS } from '../../../constants/request'
import { NUMBER_SIZE } from '../../../constants/size'
import { useInitData, useLinkLikeClick } from '../../../hooks'
import { getRequestProfilePathname } from '../../../utils/link'
import { EntityStatus } from '../../Entity'

import * as styles from './ServiceRequestsWidgetItemContent.module.css'

function ServiceRequestsWidgetItemContent({
  ContentContainer,
  profileLinkParams,
  status,
  value,
  ...restProps
}) {
  const { handleClick, handleMouseDown } = useLinkLikeClick()

  const { availableSections } = useInitData()

  const link = getRequestProfilePathname({
    additionalParams: profileLinkParams,
    availableSections,
    id: value,
  })

  function handleClickTitle(event) {
    handleClick({ event, link })
  }

  function handleMouseDownTitle(event) {
    handleMouseDown({ event, link })
  }

  return (
    <ContentContainer
      {...restProps}
      onClickTitle={handleClickTitle}
      onMouseDownTitle={handleMouseDownTitle}
    >
      <EntityStatus
        className={styles.status}
        height={NUMBER_SIZE.size20}
        id={status}
        statuses={REQUEST_STATUS}
      />
    </ContentContainer>
  )
}

export default ServiceRequestsWidgetItemContent
